import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';

//components//
import withLocalization from '~/hoc/withLocalization';
import Toggle2FAModal from './Toggle2FAModal';
import WagetypeRefetch from '../WagetypeRefetch.js';

//elements//
import { Input } from '../../../../elements/Input';
import Select from '../../../../elements/Select.js';
import SwitchWidget from '../SwitchWidget';

//utils//
import { translateLabels, resolveWageTypeCodeLabel } from '~/utils/commonMethods.js';
import { payrollIntegrationOptions, DEFAULT_TIMELOG_NORMAL_HOURS_WAGE_TYPE, WAGE_TYPE_HOURLY_FALLBACK_NOTE } from '../../../../utils/constants.js';
import RequiredStar from '../../../../elements/RequiredStar.js';

//constants//
const timelogsApprovalOptions = [{ value: 'auto', label: 'Automatic', title: 'Automatic', key: 'Automatic' },
{ value: 'auto-no-overtime', label: 'Automatic if no overtimes', title: 'Automatic if no overtimes', key: 'Automatic if no overtimes' },
{ value: 'manual', label: 'manual', title: 'manual', key: 'manual' }]

const absenceVacationApprovalOptions = [{ value: 'auto', label: 'Automatic', title: 'Automatic', key: 'Automatic' },
{ value: 'manual', label: 'Manual', title: 'Manual', key: 'Manual' }]


class General extends Component {
    constructor(props) {
        super(props);
        this.hasCompanyShifts = false;
        this.currentIntegrationProduct = props.commonStore?.config?.integration_details?.product || null;
        this.state = {
            generalRules: {
                allowManualTimelogChange: false,
                displayCommentAfterFinish: false,
                allowQucikChecklist: false,
                quickCheckListText: 'Did you get any injury at site today?',
                approvalAbsents: 'manual',
                approvalTimelogs: 'manual',
                approvalVacations: 'manual',
                maxHouresToEditWorkingHours: 48,
                workinghourUserphoto: false,
                workinghourGPSObligatory: false,
                signatureModalAfterWorklog: false,
                messageSetting: "read_write", // members default setting
                hideBreakButton: false,
                hideSensitiveDetailsFromPM: false,
                allowMutiTaskTimesheets: false,
                allowImportFromExcel: false,
                allowManagingTimelogsManually: false,
                preventPmSelfApproval: false
            },
            defaultDays: [{ day: 'Mon', checked: false }, { day: 'Tue', checked: false },
            { day: 'Wed', checked: false }, { day: 'Thu', checked: false },
            { day: 'Fri', checked: false }, { day: 'Sat', checked: false },
            { day: 'Sun', checked: false }],
            enable_2fa: false,
            show2FAModal: false,
            pending2FAValue: false,
            timelogNormalHoursWageTypes: {},
            wageType: props.commonStore.getWageTypesAccordingToIntegrations(props.commonStore?.config?.integration_details, this.getNormalHoursWageTypeCode()) || [],
            lastUpdated: props.commonStore.getWageTypesAccordingToIntegrations(props.commonStore?.config?.integration_details, 'last_updated') || null,
            isLoadingWageTypes: false,
            showAllWageTypes: false,
        }
        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.loadData = this.loadData.bind(this);
    }

    loadData = () => {
        const { currentEntity } = this.props.clientStore;
        const { generalRules } = this.state;
        const isTripletex = this.currentIntegrationProduct === payrollIntegrationOptions.TRIPLETEX;
        if (currentEntity?.client?.data?.basicRules) {
            const basicRules = Object.assign({}, currentEntity.client.data.basicRules);
            generalRules.allowManualTimelogChange = basicRules.allowManualTimelogChange ? basicRules.allowManualTimelogChange : false;
            generalRules.displayCommentAfterFinish = basicRules.displayCommentAfterFinish ? basicRules.displayCommentAfterFinish : false;
            generalRules.allowQucikChecklist = basicRules.allowQucikChecklist ? basicRules.allowQucikChecklist : false;
            generalRules.quickCheckListText = basicRules.quickCheckListText ? basicRules.quickCheckListText : 'Did you get any injury at site today?';
            generalRules.approvalAbsents = basicRules.approvalAbsents ? basicRules.approvalAbsents : 'manual';
            generalRules.approvalTimelogs = basicRules.approvalTimelogs ? basicRules.approvalTimelogs : 'manual';
            generalRules.approvalVacations = basicRules.approvalVacations ? basicRules.approvalVacations : 'manual';
            generalRules.maxHouresToEditWorkingHours = basicRules.maxHouresToEditWorkingHours ? basicRules.maxHouresToEditWorkingHours : 48;
            generalRules.workinghourUserphoto = basicRules.workinghourUserphoto ? basicRules.workinghourUserphoto : false;
            generalRules.workinghourGPSObligatory = basicRules.workinghourGPSObligatory ? basicRules.workinghourGPSObligatory : false;
            generalRules.signatureModalAfterWorklog = basicRules.signatureModalAfterWorklog ? basicRules.signatureModalAfterWorklog : false;
            generalRules.messageSetting = basicRules.messageSetting ? basicRules.messageSetting : "read_write";
            generalRules.hideBreakButton = basicRules.hideBreakButton ? basicRules.hideBreakButton : false;
            generalRules.hideSensitiveDetailsFromPM = basicRules.hideSensitiveDetailsFromPM ? basicRules.hideSensitiveDetailsFromPM : false;
            generalRules.allowMutiTaskTimesheets = isTripletex ? false : (basicRules.allowMutiTaskTimesheets || false);
            generalRules.allowImportFromExcel = basicRules.allowImportFromExcel ? basicRules.allowImportFromExcel : false;
            generalRules.allowManagingTimelogsManually = basicRules.allowManagingTimelogsManually ? basicRules.allowManagingTimelogsManually : false;
            generalRules.preventPmSelfApproval = basicRules.preventPmSelfApproval ? basicRules.preventPmSelfApproval : false;
            if (isTripletex) this.props.handleUserDataChange('allowMutiTaskTimesheets', false);
            if (currentEntity.client.allow_company_shifts)
                this.hasCompanyShifts = true;
            this.setState({
                generalRules,
                enable_2fa: !!currentEntity.client.enable_2fa,
                timelogNormalHoursWageTypes: basicRules.timelogNormalHoursWageTypes || {},
            });
        }
    }

    handleWageTypeChange = (key, value) => {
        const timelogNormalHoursWageTypes = { ...this.state.timelogNormalHoursWageTypes, [key]: value || undefined };
        this.props.handleUserDataChange('timelogNormalHoursWageTypes', timelogNormalHoursWageTypes);
        this.setState({ timelogNormalHoursWageTypes });
    }

    // Visma's 'at' category covers ordinary/regular hours as well as overtime; Xledger's 'su' category
    // is our own locally-computed "WORKING_HOURS" grouping, which is the correct one there.
    getNormalHoursWageTypeCode = () => this.currentIntegrationProduct === payrollIntegrationOptions.VISMA ? 'at' : 'su';

    refetchWageType = async () => {
        const { commonStore, t } = this.props;
        try {
            await commonStore.refetchWagetypes();
            commonStore.addNotification(t('Successfully refetched wagetypes'), null, 'success');
            const _wagetype = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, this.getNormalHoursWageTypeCode()) || [];
            const _lastUpdated = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'last_updated') || null;
            this.setState({ wageType: _wagetype, lastUpdated: _lastUpdated, isLoadingWageTypes: false });

        } catch (err) {
            console.error(err);
            commonStore.addNotification(t('Something went wrong'), null, 'error');
            this.setState({ isLoadingWageTypes: false });
        }
    }

    componentDidMount() {
        this.loadData();
    }

    handleTextChange = (name, value) => {
        const { generalRules } = this.state;
        generalRules[name] = value;
        this.props.handleUserDataChange(name, value);
        this.setState({ generalRules });
    }

    handleSwitch = (name, evt) => {
        const { generalRules } = this.state;
        const { t } = this.props;
        generalRules[name] = evt;
        this.props.handleUserDataChange(name, evt);
        if (name === 'allowManagingTimelogsManually' && !evt) {
            this.handleSwitch('allowRegisteringAbsenceWithMandatoryTimesheets', false);
        }
        this.setState({ generalRules });
    }

    render() {
        const { generalRules, wageType, lastUpdated, isLoadingWageTypes, timelogNormalHoursWageTypes, showAllWageTypes } = this.state;
        const { t, commonStore } = this.props;
        const isXledgerOrTripletex = this.currentIntegrationProduct === payrollIntegrationOptions.XLEDGER || this.currentIntegrationProduct === payrollIntegrationOptions.TRIPLETEX;
        const allWageTypesCombined = commonStore.getAllWageTypesCombined();
        const wageTypeOptions = (showAllWageTypes ? allWageTypesCombined : wageType)?.map(item => ({ value: item.value, label: item.label }));
        translateLabels(timelogsApprovalOptions, t, 'label');
        translateLabels(absenceVacationApprovalOptions, t, 'label');
        const isTripletex = this.currentIntegrationProduct === payrollIntegrationOptions.TRIPLETEX ? true : false;
        const timelogsApprovalOptionsForRender = timelogsApprovalOptions;
        const defaultNormalHoursWageTypeCode = DEFAULT_TIMELOG_NORMAL_HOURS_WAGE_TYPE[this.currentIntegrationProduct];
        const defaultNormalHoursWageType = resolveWageTypeCodeLabel(defaultNormalHoursWageTypeCode, commonStore);
        const normalHoursWageTypeNote = isTripletex
            ? t('Tripletex syncs normal timesheet hours by project and activity, not wage type - this setting is not required for Tripletex.')
            : `${t(WAGE_TYPE_HOURLY_FALLBACK_NOTE)}${defaultNormalHoursWageType ? ` ${t('If left blank, the system will use its built-in default wage type')}: "${defaultNormalHoursWageType}".` : ''}`;
        return (
            <div>
                <Row className='mt-2'>
                    <label className="control-label font-size-15 mt-2 font-color-primary">{t('Timesheet settings')}</label>
                </Row>
                {!!(wageType?.length || allWageTypesCombined?.length) &&
                    <>
                        <Row className="mt-2">
                            <label className="control-label">{t('Normal Timesheet Wage Type')}</label>
                        </Row>
                        <WagetypeRefetch
                            t={t}
                            refetch={() => this.setState({ isLoadingWageTypes: true }, this.refetchWageType)}
                            lastUpdated={lastUpdated}
                            isLoading={isLoadingWageTypes}
                            dateTimeRules={this.props.commonStore.getDateTimeRules()}
                            extraNote={normalHoursWageTypeNote}
                            showAllWageTypes={showAllWageTypes}
                            onToggleShowAllWageTypes={isTripletex ? null : (value) => this.setState({ showAllWageTypes: value })}
                        />
                        <Row className="mt-2">
                            <Col xs={12} sm={6}>
                                <label className="control-label">
                                    {isXledgerOrTripletex ? t('Activity') : t('Wage Type')} ({t('Fixed Salary')})
                                </label>
                                <Select
                                    options={wageTypeOptions || []}
                                    value={wageTypeOptions?.find(item => item.value === timelogNormalHoursWageTypes?.fixed?.value)}
                                    onChange={value => this.handleWageTypeChange('fixed', value)}
                                    isClearable
                                    isDisabled={isTripletex}
                                    placeholder={isXledgerOrTripletex ? t('Select Activity') : t('Select Wage Type')}
                                />
                            </Col>
                            <Col xs={12} sm={6}>
                                <label className="control-label">
                                    {isXledgerOrTripletex ? t('Activity') : t('Wage Type')} ({t('Hourly')})
                                </label>
                                <Select
                                    options={wageTypeOptions || []}
                                    value={wageTypeOptions?.find(item => item.value === timelogNormalHoursWageTypes?.hourly?.value)}
                                    onChange={value => this.handleWageTypeChange('hourly', value)}
                                    isClearable
                                    isDisabled={isTripletex}
                                    placeholder={isXledgerOrTripletex ? t('Select Activity') : t('Select Wage Type')}
                                />
                            </Col>
                        </Row>
                        <hr />
                    </>
                }
                <Row className='align-items-end'>
                    <Col sm={6}>
                        <Row>
                            <Col sm={2} className="mt-1">
                                <SwitchWidget
                                    value={generalRules.allowQucikChecklist}
                                    onChange={checked => this.handleSwitch('allowQucikChecklist', checked)} />
                            </Col>
                            <Col sm={10}>
                                <label className="control-label">{t('Show quick query in mobile app')}</label>
                                <OverlayTrigger
                                    placement="right"
                                    overlay={
                                        <Tooltip id="tooltip-top">
                                            {t(`If this option is enabled in the control panel, it will be available in the mobile app. When the user finishes their work, they can inform if any mishap occurred, and all project managers will be notified immediately`)}.
                                        </Tooltip>
                                    }
                                >
                                    <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                </OverlayTrigger>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={6}>
                        <Input
                            label={`${t('Quick query text')}`}
                            value={generalRules.quickCheckListText}
                            disabled={!generalRules.allowQucikChecklist}
                            onChange={evt => {
                                this.handleTextChange('quickCheckListText', evt.target.value);
                            }}
                        />
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col className="mt-1" sm={1}>
                        <SwitchWidget
                            value={generalRules.allowManualTimelogChange}
                            onChange={checked => this.handleSwitch('allowManualTimelogChange', checked)} />
                    </Col>
                    <Col sm={10}>
                        <label className="control-label">{t('Allow changes on timesheet without switching to manual mode')}</label>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("A project manager or administrator can modify a work log without it being shown as manually changed in the time log")}
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col className="mt-1" sm={1}>
                        <SwitchWidget
                            value={generalRules.hideBreakButton}
                            onChange={checked => this.handleSwitch('hideBreakButton', checked)} />
                    </Col>
                    <Col sm={11}>
                        <label className="control-label">{t('Hide break button in working hours')}</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("This rule will not show break button in working hours both in mobile app and web. System will calculate break time automatically according to selected rules of the break.")}
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col className="mt-1" sm={1}>
                        <SwitchWidget
                            value={isTripletex ? false : generalRules.allowMutiTaskTimesheets}
                            disabled={isTripletex}
                            onChange={(checked) => !(isTripletex) && this.handleSwitch('allowMutiTaskTimesheets', checked)} />
                    </Col>
                    <Col sm={11}>
                        <label className="control-label">{t("Enable Daily Timesheet Aggregation")}</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {isTripletex ? t("This rule is disabled for Tripletex integration.") : t("When enabled, all timesheets logged in a day are combined for Overtime, additional, and Flexitime calculations (with exception to Urgent Work and Mandatory overtime/flexitime logs). In tab devices, task switching will automatically stop and start new logs. When disabled, each timesheet is calculated separately.")}
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                {this.hasCompanyShifts &&
                    <Row className="mt-2">
                        <Col className="mt-1" sm={1}>
                            <SwitchWidget
                                value={generalRules.allowManagingTimelogsManually}
                                onChange={checked => this.handleSwitch('allowManagingTimelogsManually', checked)} />
                        </Col>
                        <Col sm={11}>
                            <label className="control-label">{t("Allow employees to add mandatory overtime/flexitime on timesheets")}</label>
                            <OverlayTrigger
                                placement="right"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t("Employees will be able to remove automatic calculations from the timesheet and add mandatory overtime/flexitime. However, this will remove the automatic calculations for overtime, flexitime, and additional payments")}
                                    </Tooltip>
                                }
                            >
                                <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                }

                <hr />
                <Row className='mt-2'>
                    <label className="control-label font-size-15 mt-2 font-color-primary">{t('Timesheet settings')}&nbsp;({t('For Mobile')})</label>
                </Row>
                <Row className="mt-2">
                    <Col className="mt-1" sm={1}>
                        <SwitchWidget
                            value={generalRules.displayCommentAfterFinish}
                            onChange={checked => this.handleSwitch('displayCommentAfterFinish', checked)} />
                    </Col>
                    <Col sm={11}>
                        <label className="control-label">{t('Allow to display comment dialog after finish work')}</label>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("When users click on the finish button in the app at the end of the day or when a task is completed, this function allows them to enter a comment on what was done during the task. A text field will pop up in the app where the user can enter the text")}.
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col className="mt-1" sm={1}>
                        <SwitchWidget
                            value={generalRules.signatureModalAfterWorklog}
                            onChange={checked => this.handleSwitch('signatureModalAfterWorklog', checked)} />
                    </Col>
                    <Col sm={11}>
                        <label className="control-label">{t('Show Signature Modal after finishing work in mobile app')}</label>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("At the end of the workday, users will be prompted to sign and confirm the work hours they have registered")}.
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col className="mt-1" sm={1}>
                        <SwitchWidget
                            value={generalRules.workinghourUserphoto}
                            onChange={checked => this.handleSwitch('workinghourUserphoto', checked)} />
                    </Col>
                    <Col sm={11}>
                        <label className="control-label">{t('Allow Capture live image of user when start working hours')}</label>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("Allow Capture live image of user when start working hours")}
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col className="mt-1" sm={1}>
                        <SwitchWidget
                            value={generalRules.workinghourGPSObligatory}
                            onChange={checked => this.handleSwitch('workinghourGPSObligatory', checked)} />
                    </Col>
                    <Col sm={11}>
                        <label className="control-label">{t('Make GPS obligatory for start/end time in mobile app, without GPS on workslogs cant be registered')}</label>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t(`If GPS is turned off on the mobile device, users cannot click on the start/end button. To use this function, make sure to register the location under address projects and tasks`
                                    )}.
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>

                <hr />
                <Row className='mt-2'>
                    <label className="control-label font-size-15 mt-2 font-color-primary">{t('General settings')}</label>
                </Row>
                <Row className="mt-2">
                    <Col className="mt-1" sm={1}>
                        <SwitchWidget
                            value={generalRules.hideSensitiveDetailsFromPM}
                            onChange={checked => this.handleSwitch('hideSensitiveDetailsFromPM', checked)} />
                    </Col>
                    <Col sm={11}>
                        <label className="control-label">{t("Hide Member's Sensitive Details from PM")}</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("By Enabling this feature PM will not be able to view and edit the sensitive details of Member like SSN, Bank details, Payment details, etc")}
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col className="mt-1" sm={1}>
                        <SwitchWidget
                            value={generalRules.preventPmSelfApproval}
                            onChange={checked => this.handleSwitch('preventPmSelfApproval', checked)} />
                    </Col>
                    <Col sm={11}>
                        <label className="control-label">{t('Prevent PM Self Approval')}</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t('When enabled, PMs cannot approve, reject or reset timesheets, absences or vacations that they created themselves.')}
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col className="mt-1" sm={1}>
                        <SwitchWidget
                            value={generalRules.allowImportFromExcel}
                            onChange={checked => this.handleSwitch('allowImportFromExcel', checked)} />
                    </Col>
                    <Col sm={11}>
                        <label className="control-label">{t("Allow Import From Excel")}</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("Allow Import From Excel")} ({t("Timebank Balance")}, {t("Used Vacation Days")}, {t("Used Parental Leaves")}, {t("Used Sick Leaves")})
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col className="mt-1" sm={1}>
                        <SwitchWidget
                            value={this.state.enable_2fa}
                            onChange={(checked) => this.setState({ show2FAModal: true, pending2FAValue: checked })} />
                    </Col>
                    <Col sm={11}>
                        <label className="control-label">{t("Enable")} {t("Two-Factor Authentication")}</label>
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("This will enforce 2FA for all users in the company. Admin/Pm will be required to have 2FA setup, Members can optionally disable 2FA. All 2FA settings will be shown under security settings.")}
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>

                <Toggle2FAModal
                    show={this.state.show2FAModal}
                    enable_2fa={this.state.pending2FAValue}
                    onHide={() => this.setState({ show2FAModal: false })}
                    onSuccess={() => this.setState({ enable_2fa: this.state.pending2FAValue, show2FAModal: false })}
                />

                <hr />
                <Row className='mt-2'>
                    <label className="control-label font-size-15 mt-2 font-color-primary">{t('Approval settings')}</label>
                </Row>
                <Row className="font-size-12 fw-bold mt-2">
                    <Col sm={12}>
                        <div>
                            <b>{t('Note')}**</b> &nbsp;
                            {this.currentIntegrationProduct
                                ? t('When automatic approval is enabled, approved timesheet hours will sync automatically with payroll, while absence and vacation entries require manual sync.')
                                : t('When automatic approval is enabled, timesheet, absence, and vacation entries will be approved automatically.')}
                        </div>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col xs={12} sm={4}>
                        <label className="control-label">{t('Time log approval')}</label>
                        <Select
                            menuPlacement={"top"}
                            options={timelogsApprovalOptionsForRender}
                            value={timelogsApprovalOptionsForRender.find(item => item.value === generalRules.approvalTimelogs)}
                            onChange={evt => this.handleSwitch('approvalTimelogs', evt.value)}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col xs={12} sm={4}>
                        <label className="control-label">{t('Vacations approval')}</label>
                        <Select
                            menuPlacement={"top"}
                            options={absenceVacationApprovalOptions}
                            value={absenceVacationApprovalOptions.find(item => item.value === generalRules.approvalVacations)}
                            onChange={evt => this.handleSwitch('approvalVacations', evt.value)}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col xs={12} sm={4}>
                        <label className="control-label">{t('Absents approval')}</label>
                        <Select
                            menuPlacement={"top"}
                            options={absenceVacationApprovalOptions}
                            value={absenceVacationApprovalOptions.find(item => item.value === generalRules.approvalAbsents)}
                            onChange={evt => this.handleSwitch('approvalAbsents', evt.value)}
                            style={{ width: '100%' }}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}
export default inject('clientStore', 'commonStore')(withLocalization(observer(General)));